import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import api from "../api";
import Grid from "./Grid";
import CampoFutebol from "./CampoFutebol";

const Card = styled.div`
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  padding: 16px;
  width: 100%;
`;

const SelectCustomizado = styled.select`
  font-size: 16px;
  padding: 8px 12px;
  margin: 0 auto 8px auto;
  display: block;
  border-radius: 8px;
  border: 1px solid #ccc;
  background-color: #f9f9f9;
  width: 100%;
  text-align: center;
  box-sizing: border-box;
`;

const InfoRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px;
  margin: 6px 0;
`;

const InfoBadge = styled.span`
  background-color: #eaf0fb;
  color: #1a5276;
  border-radius: 6px;
  padding: 4px 10px;
  font-size: 13px;
  font-weight: 600;
`;

const ButtonRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px;
  margin: 10px 0 4px 0;
`;

const BtnAtualizar = styled.button`
  padding: 8px 18px;
  border: none;
  border-radius: 6px;
  background-color: #27ae60;
  color: white;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;

  &:disabled {
    background-color: #95a5a6;
    cursor: not-allowed;
  }

  &:hover:not(:disabled) {
    background-color: #1e8449;
  }
`;

const BtnLiquidar = styled.button`
  padding: 8px 18px;
  border: none;
  border-radius: 6px;
  background-color: #e67e22;
  color: white;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;

  &:disabled {
    background-color: #95a5a6;
    cursor: not-allowed;
  }

  &:hover:not(:disabled) {
    background-color: #ca6f1e;
  }
`;

const BtnImportar = styled.button`
  padding: 8px 18px;
  border: none;
  border-radius: 6px;
  background-color: #2980b9;
  color: white;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #1f618d;
  }
`;

const VencedoresBox = styled.div`
  background: linear-gradient(135deg, #f6d365 0%, #fda085 100%);
  border-radius: 10px;
  padding: 14px 16px;
  margin-bottom: 4px;
`;

const VencedorTitle = styled.h3`
  text-align: center;
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 8px;
  color: #4a2c00;
`;

const VencedorLinha = styled.div`
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 4px;
  color: #2c1a00;
`;

const TabRow = styled.div`
  display: flex;
  gap: 6px;
  margin-top: 10px;
`;

const TabBtn = styled.button`
  flex: 1;
  padding: 10px;
  border: 2px solid ${props => props.ativo ? "#1a5276" : "#ddd"};
  background: ${props => props.ativo ? "#1a5276" : "#f9f9f9"};
  color: ${props => props.ativo ? "white" : "#555"};
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  &:hover {
    border-color: #1a5276;
  }
`;

const LoadingBox = styled.div`
  text-align: center;
  padding: 28px 16px;
  color: #888;
  font-size: 15px;
`;

const ClassifWrapper = styled.div`
  overflow-x: auto;
`;

const ClassifTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  min-width: 280px;
`;

const ClassifTh = styled.th`
  background: #1a5276;
  color: white;
  padding: 10px 12px;
  text-align: left;
  font-size: 13px;
  font-weight: 600;
`;

const ClassifTd = styled.td`
  padding: 10px 12px;
  font-size: 14px;
`;

const ClassifPos = styled.span`
  font-weight: 700;
  color: #1a5276;
  font-size: 15px;
`;

export function adicionaZero(numero) {
  if (numero <= 9)
    return "0" + numero;
  else
    return numero;
}

export function DataHora(data) {
  const dt = new Date(data);
  return dt.toLocaleString("pt-BR", {
    timeZone: "America/Sao_Paulo",
    day: "2-digit", month: "2-digit", year: "2-digit",
    hour: "2-digit", minute: "2-digit"
  });
}

function ListaVencedores(dados) {
  return dados
    .filter(x => x.confirmado)
    .sort((a, b) => b.pontuacao - a.pontuacao)
    .slice(0, 3);
}

const DadosRodada = ({ isAdmin = false, user = null }) => {
  const [ligas, setLigas] = useState([]);
  const [ligaSelecionada, setLigaSelecionada] = useState(null);
  const [rodadas, setRodadas] = useState([]);
  const [rodadaSelecionada, setRodadaSelecionada] = useState(null);
  const [dadosRodada, setDadosRodada] = useState([]);
  const [atualizando, setAtualizando] = useState(false);
  const [atualizandoAbertura, setAtualizandoAbertura] = useState(false);
  const [liquidando, setLiquidando] = useState(false);
  const [carregando, setCarregando] = useState(false);
  const [abaAtiva, setAbaAtiva] = useState("rodada");
  const [classificacao, setClassificacao] = useState([]);
  const [classificacaoCarregando, setClassificacaoCarregando] = useState(false);
  const [campoAberto, setCampoAberto] = useState(false);
  const [timeCampo, setTimeCampo] = useState(null);

  const ligaReqIdRef = useRef(0);
  const rodadaReqIdRef = useRef(0);

  useEffect(() => {
    carregarLigas();
  }, []);

  useEffect(() => {
    if (ligaSelecionada === null) return;
    const reqId = ++ligaReqIdRef.current;
    setRodadas([]);
    setRodadaSelecionada(null);
    setDadosRodada([]);
    listarRodadas(ligaSelecionada, reqId);
  }, [ligaSelecionada]);

  useEffect(() => {
    if (rodadaSelecionada === null) return;
    const reqId = ++rodadaReqIdRef.current;
    buscarRodada(rodadaSelecionada, reqId);
  }, [rodadaSelecionada]);

  useEffect(() => {
    if (abaAtiva === "classificacao" && ligaSelecionada !== null) {
      carregarClassificacao(ligaSelecionada);
    }
  }, [abaAtiva, ligaSelecionada]);

  async function carregarLigas() {
    try {
      const res = await api.get("liga/listarLigas");
      const lista = Array.isArray(res.data) ? [...res.data] : [];
      lista.sort((a, b) => {
        const ordemA = Number(a?.ordenacao ?? 0);
        const ordemB = Number(b?.ordenacao ?? 0);
        if (ordemA !== ordemB) return ordemA - ordemB;

        const anoA = Number(a?.ano ?? 0);
        const anoB = Number(b?.ano ?? 0);
        if (anoA !== anoB) return anoB - anoA;

        return Number(b?.id ?? 0) - Number(a?.id ?? 0);
      });

      setLigas(lista);
      if (lista.length > 0) {
        setLigaSelecionada(lista[0].id);
      }
    } catch (error) {
      console.error(error);
    }
  }

  async function listarRodadas(idLiga, reqId) {
    try {
      const res = await api.get(`liga/listarRodadas/${idLiga}`);
      if (ligaReqIdRef.current !== reqId) return;
      const rodadasOrdenadas = res.data.sort((a, b) => b.rodada - a.rodada);
      setRodadas(rodadasOrdenadas);
      if (rodadasOrdenadas.length > 0) {
        setRodadaSelecionada(rodadasOrdenadas[0].id);
      }
    } catch (error) {
      console.error(error);
    }
  }

  async function buscarRodada(idRodada, reqId) {
    setCarregando(true);
    try {
      const res = await api.get("liga/listarRodada/" + idRodada);
      if (rodadaReqIdRef.current !== reqId) return;
      const dados = Array.isArray(res.data) ? res.data : [];
      setDadosRodada(dados);

      const mercadoFechado = dados[0]?.fimRodada ? new Date(dados[0].fimRodada) <= new Date() : false;
      const liquidada = !!dados[0]?.liquidada;

      // Atualiza em segundo plano para não bloquear abertura da tela.
      if (mercadoFechado && !liquidada) {
        atualizarParciaisEmSegundoPlano(idRodada, reqId);
      }
    } catch (error) {
      console.error(error);
    } finally {
      if (rodadaReqIdRef.current === reqId) setCarregando(false);
    }
  }

  async function atualizarParciaisEmSegundoPlano(idRodada, reqId) {
    if (!idRodada || atualizandoAbertura) return;

    setAtualizandoAbertura(true);
    try {
      const res = await api.get("liga/parciaisRodada/" + idRodada);
      if (rodadaReqIdRef.current !== reqId) return;
      setDadosRodada(Array.isArray(res.data) ? res.data : []);
    } catch (error) {
      console.error(error);
    } finally {
      if (rodadaReqIdRef.current === reqId) setAtualizandoAbertura(false);
    }
  }

  async function carregarClassificacao(idLiga) {
    setClassificacaoCarregando(true);
    try {
      const res = await api.get(`liga/classificacao/${idLiga}`);
      setClassificacao(res.data);
    } catch (error) {
      console.error(error);
    } finally {
      setClassificacaoCarregando(false);
    }
  }

  async function handleAtualizarParciais() {
    if (atualizando || atualizandoAbertura || !rodadaSelecionada) return;
    setAtualizando(true);
    try {
      const res = await api.get("liga/parciaisRodada/" + rodadaSelecionada);
      setDadosRodada(Array.isArray(res.data) ? res.data : []);
    } catch (error) {
      console.error(error);
      alert("Erro ao buscar parciais. Tente novamente.");
    } finally {
      setAtualizando(false);
    }
  }

  async function handleLiquidar() {
    if (liquidando || dadosRodada[0]?.liquidada) return;

    const senha = window.prompt("Senha de liquidação:");
    if (senha === null) return;

    if (senha === '1qaz2wsX') {
      setLiquidando(true);
      try {
        const res = await api.get("liga/atualizaParciaisDaRodada/" + dadosRodada[0].idRodada);
        setDadosRodada(res.data);
        alert(`Rodada ${dadosRodada[0].rodada} liquidada!`);
      } catch (error) {
        alert("Erro ao liquidar rodada.");
      } finally {
        setLiquidando(false);
      }
    } else {
      alert("Senha incorreta!");
    }
  }

  function handleLigaChange(event) {
    setLigaSelecionada(Number(event.target.value));
  }

  function handleRodadaChange(event) {
    setRodadaSelecionada(Number(event.target.value));
  }

  const liquidada = dadosRodada[0]?.liquidada;
  const mercadoFechado = dadosRodada[0]?.fimRodada ? new Date(dadosRodada[0].fimRodada) <= new Date() : false;

  const abrirCampo = (item) => {
    setTimeCampo(item);
    setCampoAberto(true);
  };
  const totalTimes = dadosRodada.length;
  const totalConfirmados = dadosRodada.filter(x => x.confirmado).length;
  const mostrarParticipantes = mercadoFechado || liquidada;
  const textoConfirmados = (mercadoFechado || liquidada)
    ? `${totalConfirmados}`
    : `${totalConfirmados}/${totalTimes}`;
  const vencedores = ListaVencedores(dadosRodada);
  const dadosExibidos = liquidada
    ? [...dadosRodada].filter(x => x.confirmado).sort((a, b) => (b.pontuacao || 0) - (a.pontuacao || 0))
    : mercadoFechado
      ? [...dadosRodada].filter(x => x.confirmado).sort((a, b) => (b.pontuacao || 0) - (a.pontuacao || 0))
      : [...dadosRodada].sort((a, b) => (a.cartoleiro || "").localeCompare(b.cartoleiro || ""));

  return (
    <>
      <Card>
        <SelectCustomizado value={ligaSelecionada || ""} onChange={handleLigaChange}>
          {ligas.map((l) => (
            <option key={l.id} value={l.id}>
              {l.nome} ({l.ano})
            </option>
          ))}
        </SelectCustomizado>
        <TabRow>
          <TabBtn ativo={abaAtiva === "rodada"} onClick={() => setAbaAtiva("rodada")}>
            📋 Rodada
          </TabBtn>
          <TabBtn ativo={abaAtiva === "classificacao"} onClick={() => setAbaAtiva("classificacao")}>
            🏅 Classificação
          </TabBtn>
        </TabRow>
      </Card>

      {abaAtiva === "rodada" && (
        <>
          <Card>
            <SelectCustomizado value={rodadaSelecionada || ""} onChange={handleRodadaChange}>
              {rodadas.map((r) => (
                <option key={r.id} value={r.id}>
                  Rodada {r.rodada}
                </option>
              ))}
            </SelectCustomizado>

            <InfoRow>
              <InfoBadge>✔ {mostrarParticipantes ? "Participantes" : "Confirmados"}: {textoConfirmados}</InfoBadge>
              <InfoBadge>🔒 Fechamento: {DataHora(dadosRodada[0]?.fimRodada)}</InfoBadge>
              {liquidada && <InfoBadge style={{ background: "#d5f5e3", color: "#1e8449" }}>✅ Liquidada</InfoBadge>}
            </InfoRow>

            <ButtonRow>
              {!liquidada && mercadoFechado && (
                <BtnAtualizar onClick={handleAtualizarParciais} disabled={atualizando || atualizandoAbertura || !rodadaSelecionada}>
                  {(atualizando || atualizandoAbertura) ? "Buscando..." : "⟳  Atualizar Parciais"}
                </BtnAtualizar>
              )}
              {dadosRodada.length > 0 && (
                <BtnImportar onClick={() => {
                  const rodadaNum = dadosRodada[0]?.rodada ?? "";
                  const ids = dadosRodada
                    .filter(t => t.idCartola)
                    .map(t => t.idCartola.trim())
                    .join(";");
                  const texto = `Rodada ${rodadaNum} Cartola Resenha =>${ids}`;
                  navigator.clipboard.writeText(texto)
                    .then(() => alert("Copiado! Cole no app Parciais."))
                    .catch(() => alert("Não foi possível copiar. Copie manualmente:\n" + texto));
                }}>
                  📋 Importar para Parciais
                </BtnImportar>
              )}
              {isAdmin && !liquidada && (
                <BtnLiquidar onClick={handleLiquidar} disabled={liquidando}>
                  {liquidando ? "Liquidando..." : "💰 Liquidar Rodada"}
                </BtnLiquidar>
              )}
            </ButtonRow>
          </Card>

          {liquidada && vencedores.length > 0 && (
            <VencedoresBox>
              <VencedorTitle>🏆 Vencedores</VencedorTitle>
              <VencedorLinha>
                🥇 1º – R$ {dadosRodada[0]?.valorPrimeiro} – {vencedores[0]?.cartoleiro} ({vencedores[0]?.nomeTime})
              </VencedorLinha>
              {vencedores[1] && (
                <VencedorLinha>
                  🥈 2º – R$ {dadosRodada[0]?.valorSegundo} – {vencedores[1]?.cartoleiro} ({vencedores[1]?.nomeTime})
                </VencedorLinha>
              )}
              {vencedores[2] && (
                <VencedorLinha>
                  🥉 3º – {dadosRodada[0]?.valorTerceiro === 5 ? "Free" : `R$ ${dadosRodada[0]?.valorTerceiro}`} – {vencedores[2]?.cartoleiro} ({vencedores[2]?.nomeTime})
                </VencedorLinha>
              )}
            </VencedoresBox>
          )}

          {carregando ? (
            <Card><LoadingBox>⏳ Carregando dados da rodada...</LoadingBox></Card>
          ) : (
            <Grid
              users={dadosExibidos}
              user={user}
              onTimeCampo={(liquidada || mercadoFechado) ? abrirCampo : null}
              setUsers={(idRodada) => {
                const reqId = ++rodadaReqIdRef.current;
                buscarRodada(idRodada, reqId);
              }}
            />
          )}
        </>
      )}

      {abaAtiva === "classificacao" && (
        <Card>
          {classificacaoCarregando ? (
            <LoadingBox>⏳ Carregando classificação...</LoadingBox>
          ) : classificacao.length === 0 ? (
            <LoadingBox>Nenhum time participou de todas as rodadas desta liga ainda.</LoadingBox>
          ) : (
            <ClassifWrapper>
              <ClassifTable>
                <thead>
                  <tr>
                    <ClassifTh>#</ClassifTh>
                    <ClassifTh>Cartoleiro</ClassifTh>
                    <ClassifTh>Time</ClassifTh>
                    <ClassifTh style={{ textAlign: "center" }}>Pts</ClassifTh>
                    <ClassifTh style={{ textAlign: "center" }}>Rod.</ClassifTh>
                  </tr>
                </thead>
                <tbody>
                  {classificacao.map((item, i) => (
                    <tr key={i} style={{ borderBottom: "1px solid #f0f0f0" }}>
                      <ClassifTd><ClassifPos>{i + 1}º</ClassifPos></ClassifTd>
                      <ClassifTd>{item.cartoleiro}</ClassifTd>
                      <ClassifTd>{item.nomeTime}</ClassifTd>
                      <ClassifTd style={{ textAlign: "center", fontWeight: 700, color: "#1e8449" }}>
                        {(item.totalPontos || 0).toFixed(2)}
                      </ClassifTd>
                      <ClassifTd style={{ textAlign: "center" }}>{item.rodadasParticipadas}</ClassifTd>
                    </tr>
                  ))}
                </tbody>
              </ClassifTable>
            </ClassifWrapper>
          )}
        </Card>
      )}

      {campoAberto && timeCampo && (
        <CampoFutebol
          idTimeRodada={timeCampo.idTimeRodada}
          nomeTime={timeCampo.nomeTime}
          onClose={() => setCampoAberto(false)}
        />
      )}
    </>
  );
};

export default DadosRodada;
